import React from 'react';

import { createStyles, Theme, withStyles, IconButton, TextField, Button } from '@material-ui/core';
import { Close }from '@material-ui/icons';

import styles from '../attachments/attachments.module.css';

import whsOrderNoteStyles from '../whs/whsOrderNote/whsOrderNote.module.css';

const materialStyles = (theme: Theme) =>
  createStyles({
    title: {
      paddingLeft: '0px'
    },
    note: {
      marginBottom: '20px'
    },
    textField: {
        width: '100%',
        '& fieldset': {
          border: 'none !important',
        }
    },
    buttonDiv: {
      marginTop: '35px'
    }
  });

interface OrderExceptionNoteProps {
  classes: any;
  awbNumber: string;
  note: string;
  handleClose: (type: string) => void;
  onChangeRemark: (event: any) => void;
  saveRemark: () => void;
};

const paymentNote = (props: OrderExceptionNoteProps) => {
  const { classes } = props;

  return (
    <div>
      <div className={ styles.overlay } onClick={() =>  props.handleClose('orderNote') }></div>
      <div className={ styles.remarksWrapper }>

        <div className={ styles.attachmentsHeader }>

          <div className={ styles.titleBlk } >
            <div className={ classes.title }>Remarks</div>
            <div className={ styles.attachmentsHeaderText }> { props.awbNumber }</div>
          </div>
          <div className={ styles.attachmentsButton } onClick={() =>  props.handleClose('orderNote') } >
            <IconButton aria-label="Close">
              <Close color="primary" />
            </IconButton> 
          </div>

        </div>

        <div className={ styles.attachmentsBody } >
          <div className={ whsOrderNoteStyles.notesTextfield }>
            <TextField
              id="outlined-multiline-flexible"
              placeholder="-- Enter notes"
              multiline
              rows="6"
              rowsMax="6"
              value={ props.note || '' }
              onChange={ (e) => props.onChangeRemark(e) }
              variant="outlined"
              className={ classes.textField }
            />
        </div>
        <div className={[whsOrderNoteStyles.buttonWrapper, classes.buttonDiv].join(" ")}>
       
          <Button
            color="primary" 
            variant="contained"
            onClick={ () => props.saveRemark() }
            className={ classes.button }
          >
            Save
          </Button>
        </div>
        </div>
    
      </div>    
    </div>
  );
}

export default withStyles(materialStyles)(paymentNote);